import("./handleScroll.js");
import("./countdown.js");
import("./imageResize.js");
import("./formUtil.js");

const submitFailed = document.getElementById("submit-failed");
const submitFailedButton = submitFailed.querySelector("button");
const submitFailedSpinner = submitFailed.querySelector(".spinner");
const submitSuccess = document.getElementById("submit-success");
const submitokButtonEle = submitSuccess.querySelector("#submitokbutton");
const submitokSpinnerEle = submitSuccess.querySelector(".spinner");

let finalPayload = null;
let mainFormData = {};
let retryCount = 0;

const REQUIRED_FIELDS_TRANSLATION = {
  NAME: "姓名",
  EMAIL: "郵件",
  EMAIL_INVALID: "电子邮件錯誤",
  "lunch-starters": "婚禮午宴 前菜",
  "lunch-main": "婚禮午宴 主餐",
  "lunch-baby-chair": "婚禮午宴 嬰兒椅需求",
  "dinner-main": "遊船晚餐 主餐",
  "dinner-baby-chair": "遊船晚餐 嬰兒椅需求",
};

const FORM_REQUIREMENTS = {
  profile: ["NAME", "EMAIL"],
  lunch: ["lunch-starters", "lunch-main", "lunch-baby-chair"],
  dinner: ["dinner-main", "dinner-baby-chair"],
};

const IS_ATTENDING = {
  lunch: "yes",
  dinner: "yes",
};

function jumpTo(id) {
  const destination = document.getElementById(id);
  destination.scrollIntoView({ block: "start", behavior: "smooth" });
}

function cacheFormData(data) {
  try {
    localStorage.setItem("rsvp-form", JSON.stringify(data));
  } catch {
    console.log("bypassing local cache");
    return null;
  }
}

function attendFunction(id) {
  const formEle = document.getElementById(id);
  const formData = new FormData(formEle);
  const menu = formEle.querySelector(".menu");
  IS_ATTENDING[id] = formData.get("ATTEND");

  if (IS_ATTENDING[id] === "no") {
    menu.classList.add("hide-menu");
  } else {
    menu.classList.remove("hide-menu");
  }
}

function validateProfileData() {
  const id = "profile";
  const formEle = document.getElementById(id);
  const formData = new FormData(formEle);
  const name = formData.get("NAME");
  const email = formData.get("EMAIL");
  const missingInput = [];

  if (!name && FORM_REQUIREMENTS[id].includes("NAME")) {
    missingInput.push("NAME");
  }

  if (!email && FORM_REQUIREMENTS[id].includes("EMAIL")) {
    missingInput.push("EMAIL");
  }

  mainFormData = { ...mainFormData, name };

  const emailInputEle = document.getElementById("Email");
  const emailRegexPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailInputEle.validity.valid || !emailRegexPattern.test(email)) {
    missingInput.push("EMAIL_INVALID");
  } else {
    mainFormData["email"] = email;
  }

  if (missingInput.length === 0) {
    cacheFormData(mainFormData);
  }

  return missingInput;
}

function validateMenuInputs(id) {
  const formEle = document.getElementById(id);
  const formData = new FormData(formEle);
  const starters = formData.get(`${id}-starters`);
  const main = formData.get(`${id}-main`);
  const babyChair = formData.get(`${id}-baby-chair`);
  const childrenFood = formData.get(`${id}-children-food`);
  const message = DOMPurify.sanitize(formData.get(`${id}-message`));
  const missingInput = [];

  if (!starters && FORM_REQUIREMENTS[id].includes(`${id}-starters`)) {
    missingInput.push(`${id}-starters`);
  }

  if (!main && FORM_REQUIREMENTS[id].includes(`${id}-main`)) {
    missingInput.push(`${id}-main`);
  }

  if (!babyChair && FORM_REQUIREMENTS[id].includes(`${id}-baby-chair`)) {
    missingInput.push(`${id}-baby-chair`);
  }

  mainFormData = {
    ...mainFormData,
    [`${id}-main`]: main,
    [`${id}-baby-chair`]: babyChair,
    [`${id}-children-food`]: childrenFood,
    [`${id}-message`]: message,
    [`${id}-starters`]: starters,
    ["lunch-dessert"]:
      document.querySelector(".lunch-dessert")?.dataset.lunchDessert ?? "",
    ["dinner-starters"]:
      document.querySelector(".dinner-starters")?.dataset.dinnerStarters ?? "",
    ["dinner-dessert"]:
      document.querySelector(".dinner-dessert")?.dataset.dinnerDessert ?? "",
  };

  if (missingInput.length > 0) {
    return { isValid: false, missingInput };
  } else {
    return { isValid: true };
  }
}

function validateFormById(is_attending, id) {
  mainFormData[`${id}-attend`] = is_attending ? "yes" : "no";
  const isMenuDataValid = validateMenuInputs(id);
  if (is_attending && !isMenuDataValid.isValid) {
    return isMenuDataValid.missingInput;
  }
  return [];
}

function sendData(data) {
  if (!data) {
    console.log(`not sending ${data}`);
    return;
  }
  console.log(data);
  function addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
  const today = new Date(),
    year = today.getFullYear(),
    month = today.getMonth() + 1,
    day = today.getDate(),
    h = addZero(today.getHours()),
    m = addZero(today.getMinutes()),
    s = addZero(today.getSeconds()),
    time = h + ":" + m + ":" + s;

  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  lockBodyScroll();
  document.getElementById("loading").style.display = "block";

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: btoa(
      new TextEncoder()
        .encode(
          JSON.stringify({ date: `${month}-${day}-${year}`, time, ...data })
        )
        .reduce((s, byte) => s + String.fromCharCode(byte), "")
    ),
  };

  fetch("https://d2j8t795q4li3r.cloudfront.net/register", options)
    .then((response) => {
      if (!response.ok) {
        throw new Error(response);
      }
      submitokButtonEle.classList.remove("hidden-submit-button");
      submitokSpinnerEle.style.display = "none";
      submitSuccess.style.display = "flex";
      console.log(response);
      return response.json();
    })
    .then((response) => console.log(response))
    .catch((err) => {
      submitFailedButton.classList.remove("hidden-submit-button");
      submitFailedSpinner.style.display = "none";
      submitFailed.style.display = "flex";
      console.error(err);
    });
}

function submitForm() {
  const is_attending_lunch = IS_ATTENDING["lunch"] === "yes";
  const is_attending_dinner = IS_ATTENDING["dinner"] === "yes";
  const missingDataAlert = [
    ...validateProfileData(),
    ...validateFormById(is_attending_lunch, "lunch"),
    ...validateFormById(is_attending_dinner, "dinner"),
  ];

  if (missingDataAlert.length > 0) {    
    document
      .getElementById("Name")
      .scrollIntoView({ block: "center", behavior: "smooth" });
    Object.keys(REQUIRED_FIELDS_TRANSLATION).forEach((requiredField) => {
      if (
        requiredField === "EMAIL_INVALID" &&
        missingDataAlert.includes(requiredField)
      ) {
        document
          .querySelector(`.email-field`)
          ?.classList.add("missing-required-field");
      } else {
        document
          .querySelector(`.${requiredField.toLowerCase()}-field`)
          ?.classList[
            missingDataAlert.includes(requiredField) ? "add" : "remove"
          ]("missing-required-field");
      }
    });

    alert(
      `Please provide: ${missingDataAlert.map((char) =>
        char.replace(/-/g, " ").toLowerCase()
      )} 
      
請填寫: ${missingDataAlert.map((char) => REQUIRED_FIELDS_TRANSLATION[char])}`
    );

    return;
  }

  const congratsMessageForm = document.getElementById("congratsMessage");
  const formData = new FormData(congratsMessageForm);
  const congratsMessage = formData.get("congrats-message");

  finalPayload = { ...mainFormData, "congrats-message": congratsMessage };

  sendData(finalPayload);
}

function submitRetry() {
  if (retryCount === 3) {
    finalPayload = null;
  }
  retryCount += 1;
  submitFailedSpinner.style.display = "block";
  submitFailedButton.classList.add("hidden-submit-button");

  if (!finalPayload) {
    submitFailed.innerHTML =
      "<div><h1>Please refresh your page.</h1><h2>請刷新頁面</h2><button onclick='window.location.reload()'>Refresh 刷新</button></div>";
    return;
  }

  sendData(finalPayload);
}

function submitok() {
  submitokSpinnerEle.style.display = "block";
  submitokButtonEle.classList.add("hidden-submit-button");

  setTimeout(() => {
    window.location.reload();
  }, 200);
}
